export default {
  有效交易量达标即可获得:`有效交易量達標即可獲得獎勵，詳情請參閱<a href="#pay-session5">活動須知</a>`,
  交易领薪计划: "基金經理成長計劃",
  为了鼓励交易者提升交易水平:
    `用交易實力爭取<span class="red">18<span class="sRed">%</span></span>年化管理費`,
  加入交易社区: "",
  即刻发起交易信号: "即時發起交易訊號",
  无限奖励月月拿: "無限獎勵月月拿",
  优享11个专属大礼: "優享10個專屬大禮",
  即刻加入: "即時加入",
  交易员等级奖励机制: `交易員等級獎勵機制`,
  EBC基于跟随人数和资金提供五档奖励:
    "EBC基於跟隨用戶數和管理資金量提供五級獎勵。",
  "/月": "/月",
  精英交易员: "菁英交易員",
  管理资金量: "管理資金量",
  跟随账户数: "跟隨用戶數",
  大师交易员: "大師交易員",
  冠军交易员: "冠軍交易員",
  明星交易员: "明星交易員",
  资金管理费: "+1%資金管理費",
  传奇交易员: "傳奇交易員",
  多层次的增值服务: "多層次的加值服務",
  EBC提供多达11项增值服务:
    "EBC提供多達11項加值服務，整合流量和媒體資源，全面提升訊號影響力。",
  "精英/大师交易员": "精英/大師",

  "7×24小时优先客服": "7*24客服",
  金融投资经典书籍礼遇: "金融投資經典書籍禮遇",
  专属VPS赞助: "專屬VPS贊助",
  订单流软件1年使用权: "訂單流軟體1年使用權",
  EBC定制大礼包: "EBC訂製大禮包",
  信号优先置顶展示: "訊號優先置頂展示",
  受邀参观海外办公室: "受邀參觀海外辦公室",
  巴萨球星联名礼包: "巴薩球星聯名禮包",
  巴萨赛场传奇之旅: "巴薩賽場傳奇之旅",
  品牌战略合作: "品牌策略合作",
  全球金融资源管家服务: "全球金融資源管家服務",
  五维指标评价系统: "五維指標評估系統",
  为交易员信号提供公开透明的评估:
    "為交易員訊號提供公開透明的評估，展現交易風格，提升曝光率，從而吸引更多跟隨者。",
  收益率: "收益率",
  历史收益率: "歷史收益率，值越高越好。",
  最大回撤: "最大回撤",
  衡量风控能力: "衡量風控能力，越低風險越小。",
  获利系数: "獲利係數",
  利润因子: "利潤因子，越高獲利能力越強",
  夏普比率: "夏普比率",
  每份风险的收益: "每份風險的收益，越高性價比越高。",
  标准差: "標準差",
  收益波动率: "收益波動率，越低越穩定。",
  以上数据仅供参考: "*以上數據僅供參考。",
  活动须知: "活動須知",
  list: [
    {
      label: "1.跟單資訊定義",
      value: [
        {label:'跟隨資金量：單一帳號的跟隨資金量 = 該帳號餘額 ÷ 跟隨訊號數。',value:[]},
        {label:'跟隨限制：每個帳號最多可同時跟隨10個訊號。',value:[]},
        {label:'有效跟隨帳號：跟隨資金量達500美元（含）以上者，計為有效跟隨帳號；未達500美元者不計入有效跟隨帳號，也不計入跟隨資金量。​',value:[]},
        {label:'有效跟隨用戶：同一EBC帳戶下，若多個有效帳號同時跟隨同一交易員（交易訊號），僅計為1個有效用戶。',value:[]},
        {label:'管理資金量：全部跟隨資金量 + 交易員（交易訊號）帳號餘額。',value:[]},
        // {label:'數據排除：交易員名下帳號跟隨自己的訊號，不計入有效跟隨用戶和跟隨資金量。',value:[]}
      ],
    },
    {
      label: "2.等級啟動與獎勵規則",
      value: [
        {label:'等級啟動：系統每小時自動評估，若管理資金量與有效用戶數同時符合某一等級要求，即視為該等級啟動。',value:[]},
        {label:'獎勵條件（需同時滿足）：',value:['當月每個自然日均達到對應交易員等級。',{innerLabel:'有效交易量(手) ≥ 交易員（交易訊號）日均餘額 × 0.2%:',innerValue:['有效交易量 = 當月平倉交易量 + 淨持倉量（扣除同品種雙向持倉後的淨部位）。','交易員（交易訊號）日均餘額 = 當月交易員（交易訊號）每日餘額總和 ÷ 當月自然日天數。','美股及ETF不計入有效交易量統計。']}]},
        {label:'獎金計算與發放：',value:['日均管理資金量 = 當月每日管理資金量總和 ÷ 當月自然日天數。','月度獎金 =（日均管理資金量 × 資金管理費率）÷ 12。','次月第一週核算上月獎勵，審核通過後發放至交易帳號。','本活動僅限真實有效的客戶參加，活動規則及有效客戶的最終解釋權歸 EBC 所有。']}
      ],
    }
  ],
  年化资金管理费: "年化資金管理費",
};
